<template>
  <v-dialog v-model="dialog" scrollable max-width="800px">
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :content="
          moderatedOperation.comments !== undefined
            ? moderatedOperation.comments.length
            : ''
        "
        :value="
          moderatedOperation.comments !== undefined
            ? moderatedOperation.comments.length
            : ''
        "
        color="red"
        overlap
      >
        <v-btn color="primary" dark v-bind="attrs" v-on="on" text>
          <v-icon left>mdi-message-reply-text</v-icon>
          {{ $t("button.comments") }}
        </v-btn>
      </v-badge>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t("title.comments.section") }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-divider />
          <div
            v-for="(comment, index) in moderatedOperation.comments"
            :key="`comment-${index}`"
          >
            <v-card>
              <v-card-title>{{ comment.author }}</v-card-title>
              <v-card-subtitle class="text-left">{{ comment.date }}</v-card-subtitle>
              <v-card-text class="text-left">{{ comment.comment }}</v-card-text>
            </v-card>
            <v-divider v-if="moderatedOperation.comments.length - 1 != index" />
          </div>
        </v-container>
      </v-card-text>
      <v-expand-transition>
        <div :v-show="true">
          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" class="without-padding-bottom">
                <v-textarea
                  v-model="newComment"
                  clearable
                  clear-icon="cancel"
                  :label="$t('input.newComment')"
                  rows="3"
                  outlined
                  hide-details
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7" />
              <v-col cols="5">
                <v-btn text @click="dialog = false">{{
                  $t("button.close")
                }}</v-btn>
                <v-btn
                  color="blue darken-1"
                  class="white--text"
                  @click="comment"
                  >{{ $t("button.comment") }}</v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  props: {
    moderatedOperation: Object
  },
  name: "ProcessingCommentLayout",
  data: () => ({
    dialog: false,
    newComment: ""
  }),
  methods: {
    comment() {
      let moment = new Date().toLocaleString();
      this.moderatedOperation.comments.push({
        author: this.$store.getters.user.username,
        date: moment,
        comment: this.newComment
      });
      this.newComment = "";
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/comment/" +
        this.moderatedOperation.object_type +
        "/" +
        this.$route.params.id;
      let data = {
        comments: this.moderatedOperation.comments
      };
      axios
        .patch(path, data)
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t('forms.comment')
          });
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: error.response.data
          });
        });
    }
  }
};
</script>
